import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbActiveModal,
  NgbModalModule,
  NgbPopoverModule,
} from '@ng-bootstrap/ng-bootstrap';
import { AgGridModule } from 'ag-grid-angular';

import { UtilSharedModule } from '../util-shared/util-shared.module';
import { LayoutSharedModule } from '../layout-shared/layout-shared.module';
import { CrossProductCardComponent } from './cross-product-card/cross-product-card.component';
import { CrossReferencesModalService } from './cross-references-modal.service';
import { CrossReferencesModalComponent } from './cross-references-modal.component';
import { CrossReferencesGridComponent } from './cross-references-grid/cross-references-grid.component';
import { CrossReferencesProductRendererComponent } from './cross-references-grid/cross-references-product-renderer/cross-references-product-renderer.component';
import { CrossReferencesOptionsRendererComponent } from './cross-references-grid/cross-references-options-renderer/cross-references-options-renderer.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    CrossReferencesModalComponent,
    CrossProductCardComponent,
    CrossReferencesGridComponent,
    CrossReferencesProductRendererComponent,
    CrossReferencesOptionsRendererComponent
  ],
  providers: [CrossReferencesModalService, NgbActiveModal],
  imports: [
    AgGridModule,
    CommonModule,
    LayoutSharedModule,
    NgbModalModule,
    NgbPopoverModule,
    RouterModule,
    UtilSharedModule,
  ],
})
export class CrossReferencesModalModule {}
